import React, { useEffect, useState } from "react";
import {
  Image,
  List,
  Carousel,
  Typography,
  Grid,
  Row,
  Col,
  Button,
  Form,
  Input,
  Modal,
  message,
  Upload,
  Collapse,
  Tag,
  TimePicker,
  Radio,
} from "antd";
import playroomService from "../../services/playroom.service";
import timingService from "../../services/timing.service";
import { useParams } from "react-router-dom";
import {
  DeleteOutlined,
  EditTwoTone,
  EnvironmentTwoTone,
  PhoneTwoTone,
  UploadOutlined,
} from "@ant-design/icons";

const { TextArea } = Input;
const { useBreakpoint } = Grid;

export default function PlayroomPage() {
  const { Panel } = Collapse;
  const { Title } = Typography;
  const { playroomId } = useParams();
  const [selectedDeleteTiming, setSelectedDeleteTiming] = useState(null);
  const [selectedDeletePackage, setSelectedDeletePackage] = useState(null);
  const [isDeleteTimingModalOpen, setIsDeleteTimingModalOpen] = useState(false);
  const [isDeletePackageModalOpen, setIsDeletePackageModalOpen] =
    useState(false);
  const [isUpdatePlayroomModalOpen, setIsUpdatePlayroomModalOpen] =
    useState(false);
  const [playroom, setPlayroom] = useState(null);
  const [timeRange, setTimeRange] = useState(null);
  const [allTimings, setAllTimings] = useState([]);
  const [nightTimings, setNightTimings] = useState([]);
  const screens = useBreakpoint();
  const [form] = Form.useForm();
  const [isPackageModalOpen, setIsPackageModalOpen] = useState(false);
  const [isAddTimingModalOpen, setIsAddTimingModalOpen] = useState(false);
  const [isPhotoModalOpen, setIsPhotoModalOpen] = useState(false);

  const [loading, setLoading] = useState(false);
  const [fileList, setFileList] = useState([]);

  useEffect(() => {
    fetchPlayroom(playroomId);
    fetchTimings(playroomId);
  }, [playroomId]);

  const fetchPlayroom = (playroomIdAttribute) => {
    playroomService
      .getById(playroomIdAttribute)
      .then((response) => {
        if (response.status === 200) {
          console.log("Igraonica:" + response.data);
          setPlayroom(response.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const fetchTimings = (playroomIdAttribute) => {
    timingService
      .getAllByPlayroomId(playroomIdAttribute)
      .then((response) => {
        if (response.status === 200) {
          let timings = response.data;

          timings = timings.sort((a, b) => {
            const [aHour, aMinute] = a.startHours.split(":").map(Number);
            const [bHour, bMinute] = b.startHours.split(":").map(Number);
            return aHour - bHour || aMinute - bMinute;
          });

          const dayTimings = timings.filter((timing) => !timing.nightTiming);
          setAllTimings(dayTimings);

          const nightTimings = timings.filter((timing) => timing.nightTiming);

          setNightTimings(nightTimings);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getFormattedTime = (hours, minutes, seconds) => {
    const formattedHours = String(hours).padStart(2, "0");
    const formattedMinutes = String(minutes).padStart(2, "0");
    const formattedSeconds = String(seconds).padStart(2, "0");

    return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
  };
  if (!playroom) {
    return <Title level={3}>Loading...</Title>;
  }
  const handlePhotoModalCancel = () => {
    setIsPhotoModalOpen(false);
  };
  const showPhotoModal = () => {
    setIsPhotoModalOpen(true);
  };
  const handlePackageModalCancel = () => {
    setIsPackageModalOpen(false);
  };
  const showPackageModal = () => {
    setIsPackageModalOpen(true);
  };
  const handleAddTimingModalCancel = () => {
    setIsAddTimingModalOpen(false);
  };
  const showAddTimingModal = () => {
    setIsAddTimingModalOpen(true);
  };
  const showDeleteTimingModal = () => {
    setIsDeleteTimingModalOpen(true);
  };
  const handleDeleteTimingModalCancel = () => {
    setIsDeleteTimingModalOpen(false);
  };
  const showDeletePackageModal = () => {
    setIsDeletePackageModalOpen(true);
  };
  const handleDeletePackageModalCancel = () => {
    setIsDeletePackageModalOpen(false);
  };
  const handleTimeChange = (time) => {
    setTimeRange(time);
  };
  const showUpdatePlayroomModal = () => {
    setIsUpdatePlayroomModalOpen(true);
  };
  const handleUpdatePlayroomModalCancel = () => {
    setIsUpdatePlayroomModalOpen(false);
  };
  const handleAddPackage = async (values) => {
    setLoading(true);
    const packageData = {
      packageName: values.packageName,
      offers: values.offersText.split(",").map((offer) => offer.trim()),
      price: Number(values.price),
      playroomId: playroomId,
    };
    try {
      // console.log(packageData);
      await playroomService.addPackage(packageData);
      message.success("Uspješno je kreiran novi paket.");
      handlePackageModalCancel();
      fetchPlayroom(playroomId);
    } catch (error) {
      message.error("Došlo je do greške pri kreiranju novog paketa!");
    } finally {
      setLoading(false);
    }
  };

  const handleAddTiming = async (values) => {
    setLoading(true);
    const [startTime, endTime] = timeRange;
    const timingData = {
      playroomId: playroomId,
      startHours: getFormattedTime(
        startTime.hour(),
        startTime.minute(),
        startTime.second()
      ),
      endHours: getFormattedTime(
        endTime.hour(),
        endTime.minute(),
        endTime.second()
      ),
      nightTiming: values.nightTiming === "da" ? true : false,
    };
    try {
      // console.log(timingData);
      await timingService.createTiming(timingData);
      message.success("Uspješno je kreiran novi termin.");
      handleAddTimingModalCancel();
      fetchTimings(playroomId);
    } catch (error) {
      message.error("Došlo je do greške pri kreiranju novog termina!");
    } finally {
      setLoading(false);
    }
  };
  const handleFileListUpload = ({ fileList }) => {
    setFileList(fileList);
  };
  const handleAddPhotos = async () => {
    try {
      if (fileList.length > 0) {
        await playroomService.uploadImage(playroomId, fileList);
        message.success("Uspješno su dodane nove slike.");
        fetchPlayroom(playroomId);
        handlePhotoModalCancel();
      } else {
        message.info("Niste izabrali nijednu sliku.");
      }
    } catch (error) {
      message.error("Došlo je do greške pri dodavanju slika!");
    }
  };
  const handleDeleteTiming = async () => {
    try {
      await timingService.deleteTimingById(selectedDeleteTiming.id);
      message.success("Uspješno je obrisan termin.");
      handleDeleteTimingModalCancel();
      fetchTimings(playroomId);
    } catch (error) {
      message.error("Došlo je do greške pri brisanju termina!");
    }
  };
  const handleDeletePackage = async () => {
    try {
      await playroomService.deletePackageById(selectedDeletePackage.id);
      message.success("Uspješno je obrisan paket.");
      handleDeletePackageModalCancel();
      fetchPlayroom(playroomId);
    } catch (error) {
      message.error("Došlo je do greške pri brisanju paketa!");
    }
  };
  const handleUpdatePlayroom = async (values) => {
    setLoading(true);
    const updatedPlayroomData = {
      name: values.name,
      location: values.location,
      contactInfo: values.contactInfo,
      maxGuestsNumber: values.maxGuestsNumber,
      bankAccountNumber: values.bankAccountNumber,
      companyNumber: values.companyNumber,
      description: values.description,
      hasFood: values.hasFood,
      maxNumberOfChildren: values.maxNumberOfChildren
    };
    try {
      // console.log(updatedPlayroomData);
      await playroomService.updatePlayroom(playroomId, updatedPlayroomData);
      message.success("Uspješno je ažurirana igraonica.");
      handleUpdatePlayroomModalCancel();
      fetchPlayroom(playroomId);
    } catch (error) {
      message.error("Došlo je do greške pri ažuriranju igraonice!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grid grid-cols-2 gap-4 p-4">
      <div className="text-white p-4 rounded">
        <Carousel arrows>
          {playroom.photos.map((photo, index) => (
            <div key={index}>
              <Image
                src={photo.photoUrl}
                alt={`Playroom ${index + 1}`}
                style={{
                  width: "100%",
                  height: screens.md ? "400px" : "250px",
                  objectFit: "cover",
                }}
              />
            </div>
          ))}
        </Carousel>
      </div>
      <div className="text-white p-4 rounded">
        <div className="flex flex-col space-y-2 p-4 bg-gray-50 rounded-lg text-base">
          <div className="flex items-center justify-between">
            <p className="text-3xl text-blue-500 font-medium">
              {playroom.name}
            </p>
            <Button
              icon={<EditTwoTone style={{ fontSize: "28px" }} />}
              type="outlined"
              onClick={showUpdatePlayroomModal}
            ></Button>
          </div>
          <p className="flex items-center space-x-2 text-gray-600">
            <PhoneTwoTone />
            <span className="font-medium">{playroom.contactInfo}</span>
          </p>
          <p className="flex items-center space-x-2 text-gray-600">
            <EnvironmentTwoTone />
            <span className="font-medium">{playroom.location}</span>
          </p>
          <p className="flex items-center space-x-2 text-gray-600">
            <span className="font-medium">
              Bankovni racun: {playroom.bankAccountNumber}
            </span>
          </p>
          <p className="flex items-center space-x-2 text-gray-600">
            <span className="font-medium">JIB: {playroom.companyNumber}</span>
          </p>
          <p className="flex items-center space-x-2 text-gray-600">
            <span className="font-medium">
              Broj odraslih: {playroom.maxGuestsNumber}
            </span>
          </p>
          <p className="flex items-center space-x-2 text-gray-600">
            <span className="font-medium">
              Broj djece: {playroom.maxNumberOfChildren}
            </span>
          </p>
          <p className="flex items-center text-left space-x-2 text-gray-600">
            <span className="font-medium">
              Opis igraonice: {playroom.description}
            </span>
          </p>
          <p className="flex items-center space-x-2 text-gray-600">
            <span className="font-medium">
              Igraonica ima hranu: {playroom.hasFood ? "Da" : "Ne"}
            </span>
          </p>
          <Button type="primary" className={"w-1/2"} onClick={showPhotoModal}>
            Dodaj sliku
          </Button>
          <Button type="primary" className={"w-1/2"} onClick={showPackageModal}>
            Dodaj paket
          </Button>
          <Button
            type="primary"
            className={"w-1/2"}
            onClick={showAddTimingModal}
          >
            Dodaj termin
          </Button>
          <Modal
            title="Nova igraonica"
            open={isUpdatePlayroomModalOpen}
            onCancel={handleUpdatePlayroomModalCancel}
            footer={[
              <Button key="cancel" onClick={handleUpdatePlayroomModalCancel}>
                Zatvori
              </Button>,
              <Button
                key="submit"
                type="primary"
                loading={loading}
                onClick={() => form.submit()}
              >
                Ažuriraj
              </Button>,
            ]}
            style={{ width: "50%" }}
            centered
          >
            <Form
              form={form}
              onFinish={handleUpdatePlayroom}
              labelCol={{ span: 5 }}
              wrapperCol={{ span: 19 }}
              labelAlign="left"
              requiredMark={false}
              initialValues={{
                name: playroom.name,
                location: playroom.location,
                contactInfo: playroom.contactInfo,
                maxGuestsNumber: playroom.maxGuestsNumber,
                bankAccountNumber: playroom.bankAccountNumber,
                companyNumber: playroom.companyNumber,
                hasFood: playroom.hasFood,
                description: playroom.description,
                maxNumberOfChildren: playroom.maxNumberOfChildren
              }}
              validateMessages={{
                required: "Potrebno je popuniti sva polja",
              }}
            >
              <Form.Item
                name="name"
                label="Naziv"
                rules={[{ required: true, message: "Unesite naziv igraonice" }]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                name="location"
                label="Lokacija"
                rules={[
                  { required: true, message: "Unesite lokaciju igraonice" },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                name="contactInfo"
                label="Kontakt"
                rules={[{ required: true, message: "Unesite kontakt telefon" }]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                name="maxGuestsNumber"
                label="Broj gostiju"
                rules={[
                  {
                    required: true,
                    message: "Unesite maksimalan broj gostiju",
                  },
                ]}
              >
                <Input type="number" />
              </Form.Item>
              <Form.Item
                name="maxNumberOfChildren"
                label="Broj djece"
                rules={[
                  {
                    required: true,
                    message: "Unesite maksimalan broj djece",
                  },
                ]}
              >
                <Input type="number" />
              </Form.Item>
              <Form.Item
                name="bankAccountNumber"
                label="Bankovni racun"
                rules={[
                  {
                    required: true,
                    message: "Unesite broj bankovnog racuna",
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                name="companyNumber"
                label="JIB"
                rules={[
                  {
                    required: true,
                    message: "Unesite JIB",
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                name="description"
                label="Opis igraonice"
                rules={[
                  {
                    required: true,
                    message: "Unesite opis igraonice",
                  },
                ]}
              >
                <TextArea />
              </Form.Item>

              <Form.Item name="hasFood" label="Hrana">
                <Radio.Group defaultValue="ne" buttonStyle="solid">
                  <Radio.Button value={true}>Da</Radio.Button>
                  <Radio.Button value={false}>Ne</Radio.Button>
                </Radio.Group>

              </Form.Item>
            </Form>
          </Modal>
          <Modal
            open={isPhotoModalOpen}
            onCancel={handlePhotoModalCancel}
            footer={[
              <Button key="cancel" onClick={handlePhotoModalCancel}>
                Zatvori
              </Button>,
              <Button
                key="submit"
                type="primary"
                loading={loading}
                onClick={() => form.submit()}
              >
                Dodaj
              </Button>,
            ]}
            centered
          >
            <Form
              form={form}
              onFinish={handleAddPhotos}
              labelCol={{ span: 5 }}
              wrapperCol={{ span: 19 }}
              labelAlign="left"
              requiredMark={false}
            >
              <Form.Item label="Slika">
                <Upload
                  multiple
                  beforeUpload={() => false}
                  onChange={handleFileListUpload}
                  fileList={fileList}
                >
                  <Button icon={<UploadOutlined />}>Izaberi sliku</Button>
                </Upload>
              </Form.Item>
            </Form>
          </Modal>
          <Modal
            title="Novi paket"
            open={isPackageModalOpen}
            onCancel={handlePackageModalCancel}
            footer={[
              <Button key="cancel" onClick={handlePackageModalCancel}>
                Zatvori
              </Button>,
              <Button
                key="submit"
                type="primary"
                loading={loading}
                onClick={() => form.submit()}
              >
                Dodaj
              </Button>,
            ]}
            centered
          >
            <Form
              form={form}
              onFinish={handleAddPackage}
              labelCol={{ span: 5 }}
              wrapperCol={{ span: 19 }}
              labelAlign="left"
              requiredMark={false}
              validateMessages={{
                required: "Potrebno je popuniti sva polja",
              }}
            >
              <Form.Item
                name="packageName"
                label="Naziv"
                rules={[{ required: true, message: "Unesite naziv paketa" }]}
              >
                <Input />
              </Form.Item>

              <Form.Item
                name="offersText"
                label="Ponude"
                rules={[
                  {
                    required: true,
                    message: "Unesite ponude (odvojene zarezima)",
                  },
                ]}
              >
                <TextArea
                  rows={4}
                  placeholder="npr. Ponuda 1, Ponuda 2, Ponuda 3"
                />
              </Form.Item>

              <Form.Item
                name="price"
                label="Cijena"
                rules={[{ required: true, message: "Unesite cijenu" }]}
              >
                <Input type="number" />
              </Form.Item>
            </Form>
          </Modal>
          <Modal
            title="Novi termin"
            open={isAddTimingModalOpen}
            onCancel={handleAddTimingModalCancel}
            footer={[
              <Button key="cancel" onClick={handleAddTimingModalCancel}>
                Zatvori
              </Button>,
              <Button
                key="submit"
                type="primary"
                loading={loading}
                onClick={() => form.submit()}
              >
                Dodaj
              </Button>,
            ]}
            centered
          >
            <Form
              form={form}
              onFinish={handleAddTiming}
              labelCol={{ span: 5 }}
              wrapperCol={{ span: 19 }}
              labelAlign="left"
              requiredMark={false}
              validateMessages={{
                required: "Potrebno je popuniti sva polja",
              }}
            >
              <Form.Item
                name="termin"
                label="Vrijeme:"
                rules={[
                  {
                    required: true,
                    message: "Unesite vrijeme termina",
                  },
                ]}
              >
                <TimePicker.RangePicker
                  minuteStep={5}
                  format="HH:mm"
                  onChange={handleTimeChange}
                  placeholder={["Početak", "Kraj"]}
                />
              </Form.Item>

              <Form.Item name="nightTiming" label="Radni dan">
                <Radio.Group defaultValue="ne" buttonStyle="solid">
                  <Radio.Button value="da">Da</Radio.Button>
                  <Radio.Button value="ne">Ne</Radio.Button>
                </Radio.Group>
              </Form.Item>
            </Form>
          </Modal>
        </div>
      </div>
      <div className="text-white p-4 rounded">
        <div className="text-white p-4 rounded">
          <p className="text-3xl flex items-center space-x-2 text-blue-500">
            <span className="font-medium">Paketi</span>
          </p>
        </div>

        <Collapse accordion style={{ alignItems: "center" }}>
          {playroom.packages.map((pkg, index) => (
            <Panel
              header={
                <p className="text-lg flex items-center text-gray-600">
                  <span className="flex justify-between items-center w-full">
                    <span className="font-medium">{pkg.packageName}</span>
                    <Button
                      danger
                      style={{
                        height: "100%",
                      }}
                      onClick={() => {
                        setSelectedDeletePackage(pkg);
                        showDeletePackageModal();
                      }}
                      onAbort={handleDeletePackageModalCancel}
                    >
                      <DeleteOutlined />
                    </Button>
                  </span>

                  <Modal
                    title="Da li želite obrisati ovaj paket?"
                    open={isDeletePackageModalOpen}
                    onCancel={handleDeletePackageModalCancel}
                    footer={[
                      <Button
                        key="cancel"
                        onClick={handleDeletePackageModalCancel}
                      >
                        Ne
                      </Button>,
                      <Button
                        key="submit"
                        type="primary"
                        loading={loading}
                        onClick={() => handleDeletePackage()}
                      >
                        Da
                      </Button>,
                    ]}
                    centered
                  >
                    {selectedDeletePackage?.packageName && (
                      <Tag className="text-base" color="blue">
                        {selectedDeletePackage.packageName}
                      </Tag>
                    )}
                  </Modal>
                </p>
              }
              key={index}
            >
              <div style={{ width: "100%" }}>
                <ul
                  style={{
                    textAlign: "left",
                    listStyleType: "disc",
                    paddingLeft: "20px",
                  }}
                >
                  {pkg.offers.map((offer, idx) => (
                    <li key={idx}>{offer}</li>
                  ))}
                </ul>
              </div>
            </Panel>
          ))}
        </Collapse>
      </div>
      <div className="text-white p-4 rounded">
        <div className="text-white p-4 rounded">
          <p className="text-3xl flex items-center space-x-2 text-blue-500">
            <span className="font-medium">Termini</span>
          </p>
        </div>
        <div className="timings-container">
          <Row gutter={16} style={{ borderWidth: "1px", borderRadius: "5%" }}>
            <Col span={12}>
              <p
                className="flex justify-center items-center text-gray-600"
                style={{ fontSize: "20px", fontWeight: "bold", margin: "0" }}
              >
                <span className="font-medium">Radni dan</span>
              </p>
              {nightTimings.length === 0 ? (
                <List bordered>
                  <List.Item style={{ justifyContent: "center" }}>
                    Nema termina
                  </List.Item>
                </List>
              ) : (
                <List
                  // bordered
                  dataSource={nightTimings}
                  renderItem={(timing) => (
                    <List.Item
                      key={timing.id}
                      style={{ color: "#000", justifyContent: "center" }}
                    >
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                          height: "30px",
                        }}
                      >
                        {" "}
                        <Tag
                          style={{
                            height: "100%",
                            justifyItems: "center",
                            alignContent: "center",
                          }}
                          className="text-base"
                          color="blue"
                        >
                          {timing.startHours.slice(0, 5)} -{" "}
                          {timing.endHours.slice(0, 5)}
                        </Tag>
                        <Button
                          danger
                          variant="outlined"
                          style={{
                            height: "100%",
                            display: "flex",
                            alignItems: "center",
                          }}
                          onClick={() => {
                            setSelectedDeleteTiming(timing);
                            showDeleteTimingModal();
                          }}
                          onAbort={handleDeleteTimingModalCancel}
                        >
                          <DeleteOutlined />
                        </Button>
                        <Modal
                          title="Da li želite obrisati ovaj termin?"
                          open={isDeleteTimingModalOpen}
                          onCancel={handleDeleteTimingModalCancel}
                          footer={[
                            <Button
                              key="cancel"
                              onClick={handleDeleteTimingModalCancel}
                            >
                              Ne
                            </Button>,
                            <Button
                              key="submit"
                              type="primary"
                              loading={loading}
                              onClick={() => handleDeleteTiming()}
                            >
                              Da
                            </Button>,
                          ]}
                          centered
                        >
                          {selectedDeleteTiming?.startHours &&
                            selectedDeleteTiming?.endHours && (
                              <Tag className="text-base" color="blue">
                                {selectedDeleteTiming.startHours.slice(0, 5)} -{" "}
                                {selectedDeleteTiming.endHours.slice(0, 5)}
                              </Tag>
                            )}
                        </Modal>
                      </span>
                    </List.Item>
                  )}
                />
              )}
            </Col>

            <Col span={12}>
              <p
                className="flex justify-center items-center text-gray-600"
                style={{ fontSize: "20px", fontWeight: "bold", margin: "0" }}
              >
                <span className="font-medium">Vikend</span>
              </p>

              {allTimings.length === 0 ? (
                <div className="font-medium" style={{ color: "#000" }}>
                  Nema termina
                </div>
              ) : (
                <List
                  // bordered

                  dataSource={allTimings}
                  renderItem={(timing) => (
                    <List.Item
                      key={timing.id}
                      style={{ color: "#000", justifyContent: "center" }}
                    >
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                          height: "30px",
                        }}
                      >
                        <Tag
                          style={{
                            height: "100%",
                            justifyItems: "center",
                            alignContent: "center",
                          }}
                          className="text-base"
                          color="blue"
                        >
                          {timing.startHours.slice(0, 5)} -{" "}
                          {timing.endHours.slice(0, 5)}
                        </Tag>

                        <Button
                          danger
                          variant="outlined"
                          style={{
                            height: "100%",
                            display: "flex",
                            alignItems: "center",
                          }}
                          onClick={() => {
                            setSelectedDeleteTiming(timing);
                            showDeleteTimingModal();
                          }}
                          onAbort={handleDeleteTimingModalCancel}
                        >
                          <DeleteOutlined />
                        </Button>
                        <Modal
                          title="Da li želite obrisati ovaj termin?"
                          open={isDeleteTimingModalOpen}
                          onCancel={handleDeleteTimingModalCancel}
                          footer={[
                            <Button
                              key="cancel"
                              onClick={handleDeleteTimingModalCancel}
                            >
                              Ne
                            </Button>,
                            <Button
                              key="submit"
                              type="primary"
                              loading={loading}
                              onClick={() => handleDeleteTiming()}
                            >
                              Da
                            </Button>,
                          ]}
                          centered
                        >
                          {selectedDeleteTiming?.startHours &&
                            selectedDeleteTiming?.endHours && (
                              <Tag className="text-base" color="blue">
                                {selectedDeleteTiming.startHours.slice(0, 5)} -{" "}
                                {selectedDeleteTiming.endHours.slice(0, 5)}
                              </Tag>
                            )}
                        </Modal>
                      </span>
                    </List.Item>
                  )}
                />
              )}
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
}
